"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _helpers = require("../../../../helpers.js");
var _GridView = require("../GridView");
var _ImageFile = _interopRequireDefault(require("../../ImageFile"));
var _Video = _interopRequireDefault(require("../../Video"));
var _gridShared = _interopRequireDefault(require("../GridView/gridShared.css"));
var _style = _interopRequireDefault(require("./style.css"));
var _FlowPlayerWrapper = _interopRequireDefault(require("../../../FlowPlayerWrapper.js"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "renderCover", function (resource) {
      var metadata = JSON.parse(resource.published_metadata) || {};
      var imageStyle = metadata.imageStyle || 'cover';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thumbImage,
        style: {
          backgroundImage: "url(".concat(resource.large, ")"),
          backgroundPosition: imageStyle === 'icon' ? '2em 100%' : 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: imageStyle === 'icon' ? '75px 75px' : imageStyle
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: resource.large,
        alt: "resource cover"
      }));
    });
    _defineProperty(_this, "renderThumbnail", function (resource, displayOptions) {
      var metadata = JSON.parse(resource.published_metadata) || {};
      if (resource.type === 'video' || (0, _GridView.isResourceImage)(resource)) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("a", _extends({
            href: "#"
          }, (0, _GridView.addViewResourceEventOnClick)(resource)), _this.renderCover(resource)),
          size: "large",
          title: resource.published_label
        }, resource.type === 'video' ? /*#__PURE__*/_react["default"].createElement(_Video["default"], {
          resource: resource
        }) : /*#__PURE__*/_react["default"].createElement(_ImageFile["default"], {
          resource: resource
        }));
      }
      if (['product'].includes(resource.type)) {
        return _this.renderCover(resource);
      }
      if (resource.type === 'survey') {
        var resourceTitle = resource.published_label;
        if (metadata.useSurveyTitle === true) {
          var _metadata$surveyInfo;
          resourceTitle = (_metadata$surveyInfo = metadata.surveyInfo) !== null && _metadata$surveyInfo !== void 0 && _metadata$surveyInfo.surveyLabel ? metadata.surveyInfo.surveyLabel : resource.published_label;
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("a", _extends({
            href: ""
          }, (0, _GridView.addViewResourceEventOnClick)(resource)), _this.renderCover(resource)),
          title: "".concat(resourceTitle, " Preview"),
          size: "large",
          contentStyle: {
            width: '1200px'
          },
          headerStyle: {
            backgroundColor: '#2F8B86',
            color: '#fff'
          },
          bodyStyle: {
            backgroundColor: '#edf2f7'
          },
          render: function render(_ref) {
            var closeModal = _ref.closeModal;
            return /*#__PURE__*/_react["default"].createElement("div", null, displayOptions.showSurveyPreviewMessage && /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                marginBottom: '2em'
              }
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "text-primary"
            }, /*#__PURE__*/_react["default"].createElement(_info["default"], null), ' ', metadata.previewText || 'This is a preview only. No responses will be collected or saved.')), /*#__PURE__*/_react["default"].createElement(_FlowPlayerWrapper["default"], {
              flowId: [metadata.surveyInfo.flowList[0].flowId],
              isPreviewMode: true,
              onComplete: closeModal
            }));
          }
        });
      }
      var courseClosed = resource.type === 'course' && !resource.courseData.isOpen;
      var linkProps = resource.type !== 'course' ? {
        target: '_blank',
        rel: 'noopener noreferrer'
      } : null;
      return /*#__PURE__*/_react["default"].createElement("a", _extends({
        href: (0, _GridView.getExternalLink)(resource),
        style: courseClosed && {
          cursor: 'not-allowed'
        } || {}
      }, linkProps, (0, _GridView.addViewResourceEventOnClick)(resource)), _this.renderCover(resource));
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        displayOptions = _this$props.displayOptions,
        getShareUrl = _this$props.getShareUrl,
        currentTab = _this$props.currentTab,
        collection = _this$props.collection,
        addToCollection = _this$props.addToCollection,
        removeFromCollection = _this$props.removeFromCollection,
        addToCollectionButtonLabel = _this$props.addToCollectionButtonLabel,
        useFavorite = _this$props.useFavorite;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _gridShared["default"].wrapper
      }, this.props.data.map(function (resource, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: resource.type === 'product' ? _gridShared["default"].productItem : _gridShared["default"].item,
          style: {
            borderLeft: resource.borderColor && "10px solid ".concat((0, _helpers.getBorderColor)(resource.borderColor))
          },
          key: resource.id
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].cardWrapper
        }, displayOptions.showThumbnail && _this2.renderThumbnail(resource, displayOptions), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_gridShared["default"].content, " ").concat(_style["default"].content)
        }, /*#__PURE__*/_react["default"].createElement("div", null, (0, _GridView.renderTitle)(resource, displayOptions), (0, _GridView.renderDescription)(resource, displayOptions)), (0, _GridView.renderFooter)(resource, displayOptions, getShareUrl, currentTab, collection, addToCollection, removeFromCollection, addToCollectionButtonLabel, useFavorite))));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  currentTab: _propTypes["default"].string,
  data: _propTypes["default"].array.isRequired,
  displayOptions: _propTypes["default"].object,
  getShareUrl: _propTypes["default"].func
});